/*!
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2022 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { DayOfWeeks } from "../constant";
import { format } from "date-fns";
import moment from "moment";

export const isValid = (dirtyDate?: any) => {
  if (!dirtyDate) return false;
  return moment(dirtyDate).isValid();
};

export const getCurrentDayInWeek = () => {
  const currentDate = new Date();
  const day = format(currentDate, "EEEE");
  return day.toUpperCase() as DayOfWeeks;
};

export const getDateInMonth = () => {
  const currentDate = new Date();
  const day = format(currentDate, "dd");
  return parseInt(day, 10);
};

export const getMonthInYear = () => {
  const currentDate = new Date();
  const day = format(currentDate, "MM");
  return parseInt(day, 10);
};

export const getCurrentTimeInDay = () => {
  const currentDate = new Date();
  const time = format(currentDate, "HH");
  return parseInt(time, 10);
};

export const calculateRemainingMinutes = (
  targetTime: string | number | Date
) => {
  if (!targetTime || targetTime === "") return 0;
  const now = new Date();
  const target = new Date(targetTime);
  const diff = target.getTime() - now.getTime();
  const minutes = Math.ceil(diff / 60000);
  // 60000ms = 1 minute
  return minutes;
};
